import {
  NoddiDurationPicker,
  type NoddiDurationPickerProps
} from '@ui-components/Inputs/NoddiDurationPicker/NoddiDurationPicker';
import { TanstackFieldError } from '../TanstackFieldError';
import { useFieldContext } from '../formContext';

type Props = Omit<NoddiDurationPickerProps, 'value' | 'onChange'>;

export const TanstackFormDurationPicker = (rest: Props) => {
  const field = useFieldContext<number>();

  return (
    <div>
      <NoddiDurationPicker
        {...rest}
        id={field.name}
        value={field.state.value}
        onChange={(value) => field.handleChange(value)}
      />
      <TanstackFieldError field={field} />
    </div>
  );
};
